export default __webpack_public_path__ + "static/media/video-sdg-1.b7324cd0.mp4";